//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** Determines the type of tag (inline or block). Block type requires an end tag. */
export const TagType = {
    /** The inline type. */
    Inline: 1,

    /** The block type. */
    Block: 2
} as const;

/** Determines the type of tag (inline or block). Block type requires an end tag. */
export const TagTypeDescription: Record<number, string> = {
    1: "Inline",

    2: "Block"
};

/** Determines the type of tag (inline or block). Block type requires an end tag. */
export type TagType = typeof TagType[keyof typeof TagType];
